import React from 'react';
import type { ChatMessageItem } from './chat.types';

/**
 * Une bulle du fil.
 *
 * Le contenu est rendu en TEXTE BRUT (`white-space: pre-wrap` cote CSS), jamais en
 * HTML : il vient d'un modele de langue, et l'interpreter ouvrirait une injection de
 * balises pour un gain nul — les reponses tiennent en trois phrases.
 */
const ChatMessage = ({ message }: { message: ChatMessageItem }) => {
  const estUtilisateur = message.role === 'user';

  const classes = [
    'centralis-chat__bulle',
    estUtilisateur ? 'centralis-chat__bulle--mienne' : 'centralis-chat__bulle--assistant',
    message.erreur ? 'centralis-chat__bulle--erreur' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes}>
      <span className="centralis-chat__auteur">{estUtilisateur ? 'Vous' : 'Assistant'}</span>
      <p className="centralis-chat__texte">{message.contenu}</p>
    </div>
  );
};

export default ChatMessage;
